import includes from 'lodash/includes'
import get from 'lodash/get'
import forOwn from 'lodash/forOwn'
import { ApolloClient, InMemoryCache, ApolloLink, split } from '@apollo/client'
import { HttpLink } from '@apollo/client/link/http'
import { onError } from '@apollo/client/link/error'
import { createUploadLink } from 'apollo-upload-client'
import { getWindow, jsonTryParse } from '@ztechapps/common.utils'
import { routesDef } from './routes'

const TOKEN_KEY = 'app-login-token'

const hasNoUserContextOperation = ({ operationName }) => {
  const whiteListOperationName = ['login', 'logout', 'fileUpload']
  return !includes(whiteListOperationName, operationName)
}

const httpErrorLink = onError(({ graphQLErrors, response, networkError }) => {
  if (graphQLErrors) {
    let errorMessage = get(graphQLErrors, '[0].message')
    errorMessage = jsonTryParse(errorMessage)
    errorMessage = get(errorMessage, '[0]')
    const exceptionCode = get(errorMessage, 'extensions.exception.code')

    if (exceptionCode === 'UNAUTHORIZED') {
      const win = getWindow()
      if (win) {
        win.localStorage.removeItem(TOKEN_KEY)
        win.localStorage.removeItem('app-login-userId')
        win.location.replace(routesDef.LoginPage.path)
      }
      return
    }

    let isValidationError = false
    forOwn(errorMessage, (_value, key) => {
      if (key === 'validationError') {
        isValidationError = true
      }
    })

    if (isValidationError) response.errors = errorMessage as never
  } else if (networkError) {
    const statusCode = get(networkError, 'statusCode')

    if (statusCode === 401) {
      const win = getWindow()
      if (win) {
        win.localStorage.removeItem(TOKEN_KEY)
        win.localStorage.removeItem('app-login-userId')
        win.location.replace(routesDef.LoginPage.path)
      }
      return
    }
  }
})

export const setupApolloClient = () => {
  const win = getWindow()
  const uri = '/graphql/'
  const loginToken = win.localStorage.getItem(TOKEN_KEY)

  const cache = new InMemoryCache()

  const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        'login-token': loginToken,
      },
    })
    return forward(operation)
  })

  const httpLink = new HttpLink({ uri })
  const uploadLink = createUploadLink({ uri })

  const transportLink = split(hasNoUserContextOperation, httpLink, uploadLink)
  const link = ApolloLink.from([authMiddleware, httpErrorLink, transportLink])

  return new ApolloClient({
    link,
    cache,
    ssrForceFetchDelay: 100,
  })
}
